import { render } from "./emm.vue?vue&type=template&id=367bc884"
import script from "./emm.vue?vue&type=script&lang=js"
export * from "./emm.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__